<template>
  <div class="home">
    <header>
      <HeaderPage />
    </header>
    <main>
      <About />
      <Skills />
      <Projects />
    </main>
    <footer>
      <ContactMe />
      <FooterPage class="footer-page" />
    </footer>
  </div>
</template>

<script>
import HeaderPage from '@/components/HeaderPage';
import About from '@/components/About';
import Skills from '@/components/Skills';
import Projects from '@/components/Projects';
import ContactMe from '@/components/ContactMe';
import FooterPage from '@/components/FooterPage';

export default {
  name: 'Home',
  components: {
    HeaderPage,
    About,
    Skills,
    Projects,
    ContactMe,
    FooterPage
  }
};
</script>

<style lang="scss" scoped>
.home {
  margin-top: 50px;
  text-align: center;
  padding: 30px 0;
  .footer-page {
    position: relative;
    bottom: -6vh;
  }
}
</style>
